module.exports = __webpack_public_path__ + "img/1443891449.96166962.jpg";